import { MDBDataTable } from "mdbreact";
import React, { useEffect, useMemo, useState } from "react";
import { MutatingDots } from "react-loader-spinner";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card, CardBody, CardTitle,
  Col,
  Row
} from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import "./datatables.scss";


const StudentRegistrationsList = (props) => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Student Registrations", link: "#" },
    { title: "Total Registrations", link: "#" },
  ];

  useEffect(() => {
    const getStudentRegistrations = async () => {
      try {
        const response = await api.get(`${backendUrl}get-all-student-registrations`);
        if (response.status === 200) {
          console.log("Fetched Student Registrations:", response.data.student_registrations);
          setRegistrations(response.data.student_registrations || []);
        }
      } catch (err) {
        toast.error("Failed to fetch student registrations");
      } finally {
        setLoading(false);
      }
    };
    getStudentRegistrations();
    props.setBreadcrumbItems("Student Registrations", breadcrumbItems);
  }, []);

  const handleEditTerm = (registration) => {
    navigate(`/update-payment-status-eligibility/${registration._id}`);
  };

  const data = useMemo(
    () => ({
      columns: [
        { label: "Roll No", field: "roll_no", sort: "asc", width: 50 },
        { label: "Name", field: "first_name", sort: "asc", width: 100 },
        { label: "Course", field: "course_name", sort: "asc", width: 150 },
        { label: "Technology", field: "technology_name", sort: "asc", width: 120 },
        { label: "Program", field: "program_name", sort: "asc", width: 120 },
        { label: "Branch", field: "branch", sort: "asc", width: 120 },
        { label: "College", field: "college", sort: "asc", width: 120 },
        { label: "Passout", field: "passout_year", sort: "asc", width: 120 },
        { label: "Payment Status", field: "payment_status", sort: "asc", width: 120 },
        { label: "Actions", field: "actions", sort: "asc", width: 100 },
      ],
      rows: registrations.map((r) => ({
        roll_no: r.roll_no || "-",
        first_name: r.first_name || "-",
        course_name: r.course_name || "-",
        technology_name: r.technology_name || "-",
        program_name: r.program_name || "-",
        branch: r.branch?.[0] || "-",
        college: r.college || "-",
        passout_year: r.passout_year || "-",
        payment_status: r.payment_status === 1 ? "Active" : "Inactive",
        actions: (
          <Button color="primary" size="sm" onClick={() => handleEditTerm(r)}>
            Edit
          </Button>
        ),
      })),
    }),
    [registrations]
  );

  return (
    <React.Fragment>
      <Row>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} transition={Bounce} />
        <Col className="col-12">
          <Card>
            <CardBody className="d-flex justify-content-between align-items-center">
              <CardTitle className="h4">Student Registrations List</CardTitle>
              <Button color="primary" onClick={() => navigate("/add-student-registration")}>
                Add Registration
              </Button>
            </CardBody>
            <CardBody>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                  <MutatingDots visible height="100" width="100" color="#2B3A4A" secondaryColor="#2B3A4A" radius="12.5" />
                </div>
              ) : (
                <MDBDataTable responsive bordered data={data} />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(StudentRegistrationsList);
